import React from 'react';

import {Badge, HStack, Text, VStack} from "@chakra-ui/react";

import {useLanguage} from "@/contexts/languageContext";
import {Skeleton} from "@/components/ui";
import stringUtil from "@/utils/stringUtil";
import dateUtil from "@/utils/dateUtil";

export const ResourceBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        maxH="6rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { stringUtil.getRandomString(10, 25) }
                </Text>
            </Skeleton>
            <HStack>
                {
                    Array.from({length: Math.floor(Math.random() * 5) }).map((_, i) => {
                        return <Skeleton key={`res-cat-ske-${i}`}>
                            <Badge fontSize=".8em">{ stringUtil.getRandomString(5, 12) }</Badge>
                        </Skeleton>
                    })
                }
            </HStack>
            <Skeleton>
                <Text
                    fontSize="sm"
                    isTruncated
                >
                    { stringUtil.getRandomString(20, 30) }
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const ResourceBody = ({element, ...props}) => {
    const {language: uiLanguage, t, availableLanguages} = useLanguage();
    const displayLang = element?.displayLanguage || uiLanguage;

    return (
        <HStack
            gap="1vw"
            minH="3.5rem"
            maxH="6rem"
            color="secondary.500"
            overflow="hidden"
            {...props}
        >
            <VStack align="flex-start" flex={1} overflow="hidden">
                <HStack>
                    <Text
                        fontWeight="bold"
                        fontSize="md"
                        isTruncated
                    >
                        {element[`${displayLang}Title`] && element[`${displayLang}Title`].length > 0 ? element[`${displayLang}Title`] : (element[`frTitle`]?.length > 0 ? element[`frTitle`] : element[`enTitle`])}
                    </Text>
                    {availableLanguages.map((lang) => {
                        if (element[`${lang}Title`] && element[`${lang}Title`].length > 0) {
                            return <Text key={lang}>{lang === 'fr' ? '🇫🇷' : '🇬🇧'}</Text>
                        }
                        return null;
                    })}
                </HStack>
                <HStack>
                    {
                        element.categories.map((category, i) => {
                            return <Badge
                                key={`res-cat-${i}`}
                                fontSize="0.8em"
                                bg={category?.color?.background}
                                color={category?.color?.text}
                            >
                                { category?.[displayLang] }
                            </Badge>
                        })
                    }
                </HStack>
                <Text
                    fontSize="sm"
                    color="secondary.500"
                    isTruncated
                >
                    {`${t('misc.publishedAt')} ${dateUtil.format(new Date(element?.createdAt), uiLanguage === 'fr' ? 'fr-FR' : 'en-US', {
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric'
                    }, '/')}`}
                </Text>
            </VStack>
        </HStack>
    );
};

export default ResourceBody;
